import { Dispatch } from "react";
import styled from "styled-components";
import {
  App,
  ProfilePictureResponse,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import { LoadingIcon, minMedium, shade950 } from "@songtradr/design-language";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = {
  ...staticText.components.profilePictureEditor,
  shared: { buttons: staticText.buttons },
};

// STYLES
export const CropContainer = styled.div<{
  $disabled: boolean;
}>`
  width: 100%;
  min-height: 20rem;
  position: relative;
  background-color: ${({ $disabled }) =>
    $disabled ? "transparent" : shade950};

  .reactEasyCrop_Container {
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1.5rem;

  @media ${minMedium} {
    flex-flow: row;
    gap: 5rem;

    > * {
      flex: 1;
    }
  }
`;

export const ImageLoadingIcon = styled(LoadingIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

// DATA

// TYPES
export type Props<ReducerActions> = {
  dispatch: Dispatch<ReducerActions>;
  updateProfilePic: (formData: FormData) => Promise<string>;
  getProfilePictureData: () => Promise<ProfilePictureResponse>;
  saveRedirect: string;
  removeProfilePic?: (adminNotes: string) => Promise<void>;

  /** Important prop - if this value is provided, the admin version of the component will render -
   *  admin endpoints/routes will be used and the admin notes modal will render on submit  */
  adminProps?: {
    modalPath: string;
    selectedUserId: string;
  };
};

// CONSTANTS
export const adminEndpoints = fullEndpoints[App.Admin];
export const accountEndpoints = fullEndpoints[App.Account];

export const validFiletypes = ["image/jpg", "image/jpeg", "image/png"];

export const defaultMeta: ProfilePictureResponse = {
  originalKey: "",
  croppedUrl: "",
  rotation: 0,
  zoom: 1,
  xCoord: 0,
  yCoord: 0,
};

// FUNCTIONS

// ASSETS
